var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "26px",
    height: "26px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.96923,253.04807) rotate(-180) scale(9.84615,9.84615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71875,11.02344l13.28125,-1v-3.14844c0,-0.32812 0.16016,-0.57422 0.48047,-0.82031c0.32031,-0.08203 0.64063,-0.08203 0.87891,0.08203c3.28125,2.29687 6.40234,6.14453 6.48047,6.30859c0.07813,0.15625 0.15234,0.39063 0.15625,0.55469c0,0.00391 0.00391,0.01172 0.00391,0.01563c0,0.16406 -0.07812,0.41016 -0.16016,0.49219c-0.07812,0.16406 -3.12109,4.02344 -6.48047,6.32031c-0.32031,0.16406 -0.64062,0.24609 -0.87891,0.08203c-0.32031,-0.16406 -0.48047,-0.41016 -0.48047,-0.73828v-3.14844l-13.28125,-1c-0.39844,-0.32031 -0.71875,-1.125 -0.71875,-2.00781c0,-0.79687 0.23828,-1.67187 0.71875,-1.99219z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowWhite);
export default __webpack_public_path__ + "static/media/left-arrow-white.167b4f186d0ff256909f37a8fe315a33.svg";
export { ForwardRef as ReactComponent };